<template>
  <div class="modal" :class="{ open: visible }" @click.self="handleClose">
    <div class="modal-spec-content" @click.stop>
      <h3>{{ productName }}</h3>
      <div class="spec-opts">
        <div
          v-for="specValue in specValues"
          :key="specValue.valueId"
          class="spec-item"
          :class="{ active: selectedSpecValue && selectedSpecValue.valueId === specValue.valueId }"
          @click="handleSelectSpec(specValue)"
        >
          <div class="spec-name">{{ specValue.specName || '默认规格' }}</div>
          <div class="spec-price">¥{{ (specValue.price || specValue.ownerPrice || 0).toFixed(2) }}</div>
        </div>
      </div>
      <button class="primary-btn" @click="handleAddToCart" :disabled="!selectedSpecValue">
        加入
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MealSpecModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: null
    }
  },
  computed: {
    productName() {
      return this.product ? this.product.name : '商品'
    },
    specValues() {
      return this.product && this.product.specValues ? this.product.specValues : []
    }
  },
  data() {
    return {
      selectedSpecValue: null
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.selectedSpecValue = null
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleSelectSpec(specValue) {
      this.selectedSpecValue = specValue
    },
    handleAddToCart() {
      if (!this.product || !this.selectedSpecValue) {
        return
      }
      this.$emit('add-to-cart', {
        ...this.product,
        valueId: this.selectedSpecValue.valueId,
        price: parseFloat(this.selectedSpecValue.price || this.selectedSpecValue.ownerPrice || 0),
        vipPrice: parseFloat(this.selectedSpecValue.vipPrice || this.selectedSpecValue.ownerPrice || 0),
        specName: this.selectedSpecValue.specName || '',
        spec: this.selectedSpecValue.specName || ''
      })
      this.handleClose()
    }
  }
}
</script>

<style scoped>
.modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 110;
}

.modal.open {
  display: flex;
}

.modal-spec-content {
  background: white;
  padding: 20px;
  border-radius: 12px;
  width: 300px;
}

.modal-spec-content h3 {
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: 600;
  color: #2D3436;
}

.spec-opts {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.spec-item {
  padding: 12px;
  background: #f5f5f5;
  border: 2px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.spec-item:hover {
  background: #eee;
}

.spec-item.active {
  background: #FFF5F5;
  border-color: #FF6B6B;
}

.spec-name {
  font-size: 14px;
  font-weight: 500;
  color: #2D3436;
}

.spec-price {
  font-size: 16px;
  font-weight: 700;
  color: #FF6B6B;
}

.primary-btn {
  width: 100%;
  padding: 15px;
  background: #FF6B6B;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.2s;
}

.primary-btn:hover:not(:disabled) {
  background: #FF5252;
}

.primary-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}
</style>

